// Sample shed inventory data for development and fallback
export const sampleSheds = [
  {
    id: 1,
    name: '10x12 Classic Barn Shed',
    brand: 'Heritage',
    dealerName: 'Rocky Mountain Sheds',
    dealerLocation: 'Denver, CO',
    model: 'Classic Barn',
    shedType: 'barn',
    size: '10x12',
    width: 10,
    depth: 12,
    height: 9.5,
    squareFeet: 120,
    price: 4999,
    salePrice: null,
    depositAmount: 500,
    onSale: false,
    salePercentage: 0,
    material: 'Wood',
    roofStyle: 'Gambrel',
    roofMaterial: 'Architectural Shingles',
    sidingType: 'LP SmartSide',
    bodyColor: 'Barn Red',
    trimColor: 'White',
    roofColor: 'Charcoal',
    floorType: 'Treated Plywood',
    foundation: 'Skid',
    doorType: 'double',
    windowType: '22x36_double',
    hasRamp: false,
    hasShelving: false,
    inventoryType: 'physical',
    condition: 'New',
    status: 'available',
    serialNumber: 'HB-2024-001',
    stockNumber: 'SH001',
    yearBuilt: 2024,
    warranty: '5-Year Limited',
    warrantyYears: 5,
    loft: true,
    workbench: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Beautiful classic barn-style storage shed with plenty of room for lawn equipment, tools, and seasonal storage. Features a spacious loft for additional storage and traditional double barn doors for easy access.',
    features: [
      '6ft Double Barn Doors',
      '2 Windows with Shutters',
      'Loft with Ladder',
      'LP SmartSide Siding',
      'Architectural Shingles',
      'Treated Floor',
      'Free Delivery & Setup'
    ],
    images: [
      '/assets/assets/images/12x24-custom-homeshed.webp',
      '/assets/assets/images/12x24-shed.webp',
      '/assets/assets/images/shed-with-deck.webp'
    ],
    videos: [],
    createdAt: '2024-01-15T10:00:00Z'
  },
  {
    id: 2,
    name: '8x10 Garden Gable Shed',
    brand: 'Heritage',
    dealerName: 'Bayou Barns',
    dealerLocation: 'Baton Rouge, LA',
    model: 'Garden Gable',
    shedType: 'gable',
    size: '8x10',
    width: 8,
    depth: 10,
    height: 8,
    squareFeet: 80,
    price: 2999,
    salePrice: 2799,
    depositAmount: 300,
    onSale: true,
    salePercentage: 7,
    material: 'Wood',
    roofStyle: 'Gable',
    roofMaterial: 'Metal',
    sidingType: 'T1-11',
    bodyColor: 'Natural Cedar',
    trimColor: 'Brown',
    roofColor: 'Green',
    floorType: 'Treated Plywood',
    foundation: 'Skid',
    doorType: 'single',
    windowType: '22x36_single',
    hasRamp: false,
    hasShelving: true,
    inventoryType: 'physical',
    condition: 'New',
    status: 'available',
    serialNumber: 'HG-2024-015',
    stockNumber: 'SH002',
    yearBuilt: 2024,
    warranty: '5-Year Limited',
    warrantyYears: 5,
    loft: false,
    workbench: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Perfect starter shed for garden tools and equipment. Compact footprint fits easily in most backyards while providing ample storage space for mowers, trimmers, and gardening supplies.',
    features: [
      '5ft Wide Single Door',
      '1 Window with Flower Box',
      'Built-in Shelving',
      'Metal Roof',
      'Natural Cedar Finish',
      'Free Delivery & Setup'
    ],
    images: [
      '/assets/assets/images/12x24-a-frameshed.webp',
      '/assets/assets/images/10x24-studio-shed-1of4.webp'
    ],
    videos: [],
    createdAt: '2024-01-20T14:30:00Z'
  },
  {
    id: 3,
    name: '12x16 Deluxe Workshop',
    brand: 'Pro Series',
    dealerName: 'Prairie Structures',
    dealerLocation: 'Bismarck, ND',
    model: 'Deluxe Workshop',
    shedType: 'workshop',
    size: '12x16',
    width: 12,
    depth: 16,
    height: 10,
    squareFeet: 192,
    price: 8999,
    salePrice: null,
    depositAmount: 1000,
    material: 'Wood',
    roofStyle: 'Gable',
    roofMaterial: 'Architectural Shingles',
    sidingType: 'LP SmartSide',
    sidingColor: 'Slate Gray',
    trimColor: 'White',
    roofColor: 'Black',
    floorType: '3/4" Treated Plywood',
    foundation: 'Concrete Runners',
    condition: 'New',
    status: 'available',
    serialNumber: 'PS-2024-008',
    stockNumber: 'SH003',
    yearBuilt: 2024,
    warranty: '10-Year Limited',
    warrantyYears: 10,
    doors: '8ft Double Door + Side Entry',
    windows: '4 - 24x36 Windows',
    loft: true,
    workbench: true,
    shelving: true,
    electrical: true,
    insulation: true,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'The ultimate workshop for serious hobbyists and craftsmen. Pre-wired for electricity with insulated walls, built-in workbench, and plenty of natural light. Perfect for woodworking, crafts, or a home office.',
    features: [
      '8ft Double Doors',
      'Side Entry Door',
      '4 Windows',
      'Pre-Wired Electrical (100A Panel)',
      'Insulated Walls & Ceiling',
      'Built-in Workbench',
      'Loft Storage',
      'Heavy-Duty Floor',
      '10-Year Warranty'
    ],
    images: [
      '/assets/assets/images/garage-shed-12x24.webp',
      '/assets/assets/images/12x24-garage-shed-2.webp'
    ],
    videos: [],
    createdAt: '2024-02-01T09:15:00Z'
  },
  {
    id: 4,
    name: '6x8 Lean-To Utility Shed',
    brand: 'Budget',
    dealerName: 'Lone Star Sheds',
    dealerLocation: 'San Antonio, TX',
    model: 'Lean-To Basic',
    shedType: 'lean-to',
    size: '6x8',
    width: 6,
    depth: 8,
    height: 7,
    squareFeet: 48,
    price: 1499,
    salePrice: null,
    depositAmount: 150,
    material: 'Metal',
    roofStyle: 'Lean-To',
    roofMaterial: 'Metal',
    sidingType: 'Galvanized Steel',
    sidingColor: 'Green',
    trimColor: 'Green',
    roofColor: 'Green',
    floorType: 'None (Customer Provides)',
    foundation: 'None',
    condition: 'New',
    status: 'available',
    serialNumber: 'BL-2024-042',
    stockNumber: 'SH004',
    yearBuilt: 2024,
    warranty: '2-Year Limited',
    warrantyYears: 2,
    doors: '5ft Single Sliding Door',
    windows: '0',
    loft: false,
    workbench: false,
    shelving: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: false,
    setupIncluded: false,
    description: 'Affordable metal storage solution perfect for basic storage needs. Lean-to design can be placed against a fence or building. Easy DIY assembly.',
    features: [
      'Sliding Door',
      'Weather-Resistant',
      'Easy Assembly',
      'Low Maintenance',
      'Rust-Resistant Coating'
    ],
    images: [
      '/assets/assets/images/10x20-studio-shed-4of4.webp',
      '/assets/assets/images/10x20-studio-shed-3of4.webp'
    ],
    videos: [],
    createdAt: '2024-02-10T11:45:00Z'
  },
  {
    id: 5,
    name: '10x16 Ranch Style Shed',
    brand: 'Heritage',
    dealerName: 'High Country Buildings',
    dealerLocation: 'Colorado Springs, CO',
    model: 'Ranch',
    shedType: 'ranch',
    size: '10x16',
    width: 10,
    depth: 16,
    height: 8.5,
    squareFeet: 160,
    price: 5999,
    salePrice: 5499,
    depositAmount: 600,
    material: 'Wood',
    roofStyle: 'Gable',
    roofMaterial: 'Architectural Shingles',
    sidingType: 'Vinyl',
    sidingColor: 'Almond',
    trimColor: 'White',
    roofColor: 'Weatherwood',
    floorType: 'Treated Plywood',
    foundation: 'Skid',
    condition: 'New',
    status: 'available',
    serialNumber: 'HR-2024-023',
    stockNumber: 'SH005',
    yearBuilt: 2024,
    warranty: '7-Year Limited',
    warrantyYears: 7,
    doors: '6ft Double Door',
    windows: '2 - 24x36 Windows',
    loft: false,
    workbench: false,
    shelving: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Classic ranch-style shed with clean lines and a low-profile design. Vinyl siding requires virtually no maintenance and looks great for years. Perfect for equipment storage or as a pool house.',
    features: [
      '6ft Double Doors',
      '2 Windows',
      'Vinyl Siding - No Painting',
      'Low Maintenance',
      'Lifetime Siding Warranty',
      'Free Delivery & Setup'
    ],
    images: [
      '/assets/assets/images/shed-with-deck.webp',
      '/assets/assets/images/12x24-custom-homeshed.webp'
    ],
    videos: [],
    createdAt: '2024-02-15T08:00:00Z'
  },
  {
    id: 6,
    name: '12x20 Two-Story Barn',
    brand: 'Pro Series',
    dealerName: 'Delta Portable Buildings',
    dealerLocation: 'Shreveport, LA',
    model: 'Two-Story Barn',
    shedType: 'barn',
    size: '12x20',
    width: 12,
    depth: 20,
    height: 16,
    squareFeet: 480,
    price: 14999,
    salePrice: null,
    depositAmount: 1500,
    material: 'Wood',
    roofStyle: 'Gambrel',
    roofMaterial: 'Architectural Shingles',
    sidingType: 'Board & Batten',
    sidingColor: 'Hunter Green',
    trimColor: 'Cream',
    roofColor: 'Black',
    floorType: '3/4" Treated Plywood',
    foundation: 'Concrete Piers',
    condition: 'New',
    status: 'reserved',
    serialNumber: 'PS-2024-003',
    stockNumber: 'SH006',
    yearBuilt: 2024,
    warranty: '10-Year Limited',
    warrantyYears: 10,
    doors: '8ft Double Barn Door + Loft Door',
    windows: '6 - 24x36 Windows',
    loft: true,
    workbench: true,
    shelving: true,
    electrical: true,
    insulation: true,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Stunning two-story barn with full second-floor loft. Perfect as a workshop, studio, home office, or guest space. Includes electrical package and insulation. A true showpiece for any property.',
    features: [
      '480 Sq Ft Total (240 per floor)',
      'Full Second Floor Loft',
      'Loft Loading Door',
      '6 Windows',
      'Pre-Wired 200A Electrical',
      'Fully Insulated',
      'Built-in Workbench',
      'Board & Batten Siding',
      'Interior Staircase',
      '10-Year Warranty'
    ],
    images: [
      '/assets/assets/images/12x24-shed.webp',
      '/assets/assets/images/10x20-studio-shed-2of4.webp'
    ],
    videos: [],
    createdAt: '2024-02-20T16:30:00Z'
  },
  {
    id: 7,
    name: '8x12 Studio Shed',
    brand: 'Modern',
    dealerName: 'NorCal Outdoor Structures',
    dealerLocation: 'Sacramento, CA',
    model: 'Studio',
    shedType: 'studio',
    size: '8x12',
    width: 8,
    depth: 12,
    height: 9,
    squareFeet: 96,
    price: 6499,
    salePrice: null,
    depositAmount: 650,
    material: 'Wood',
    roofStyle: 'Flat/Modern',
    roofMaterial: 'EPDM Membrane',
    sidingType: 'Cedar',
    sidingColor: 'Natural',
    trimColor: 'Black',
    roofColor: 'Black',
    floorType: 'Engineered Wood',
    foundation: 'Concrete Deck Blocks',
    condition: 'New',
    status: 'available',
    serialNumber: 'MS-2024-011',
    stockNumber: 'SH007',
    yearBuilt: 2024,
    warranty: '7-Year Limited',
    warrantyYears: 7,
    doors: 'French Doors with Glass',
    windows: '3 - Large Picture Windows',
    loft: false,
    workbench: false,
    shelving: false,
    electrical: true,
    insulation: true,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Contemporary studio shed with modern design. Perfect for a home office, art studio, yoga room, or she-shed/man-cave. Lots of natural light with floor-to-ceiling windows and glass French doors.',
    features: [
      'Modern Flat Roof Design',
      'French Doors with Glass',
      'Large Picture Windows',
      'Natural Cedar Exterior',
      'Pre-Wired Electrical',
      'Fully Insulated',
      'Engineered Wood Floor',
      'Ready for HVAC'
    ],
    images: [
      '/assets/assets/images/10x20-studio-shed-2of4.webp',
      '/assets/assets/images/10x20-studio-shed-3of4.webp'
    ],
    videos: [],
    createdAt: '2024-03-01T10:00:00Z'
  },
  {
    id: 8,
    name: '10x10 Cottage Shed',
    brand: 'Heritage',
    dealerName: 'Plains Storage Solutions',
    dealerLocation: 'Sioux Falls, SD',
    model: 'Cottage',
    shedType: 'cottage',
    size: '10x10',
    width: 10,
    depth: 10,
    height: 9,
    squareFeet: 100,
    price: 4299,
    salePrice: 3999,
    depositAmount: 400,
    material: 'Wood',
    roofStyle: 'Gable with Dormer',
    roofMaterial: 'Architectural Shingles',
    sidingType: 'Clapboard',
    sidingColor: 'Cape Cod Gray',
    trimColor: 'White',
    roofColor: 'Driftwood',
    floorType: 'Treated Plywood',
    foundation: 'Skid',
    condition: 'New',
    status: 'available',
    serialNumber: 'HC-2024-019',
    stockNumber: 'SH008',
    yearBuilt: 2024,
    warranty: '5-Year Limited',
    warrantyYears: 5,
    doors: 'Single Door with Glass',
    windows: '3 - Cottage Windows with Grids',
    loft: true,
    workbench: false,
    shelving: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Charming cottage-style shed adds character to any backyard. Features a decorative dormer, traditional clapboard siding, and cottage-style windows with grids. Great as a garden shed or she-shed.',
    features: [
      'Decorative Dormer',
      'Clapboard Siding',
      'Cottage Windows with Grids',
      'Door with Glass Insert',
      'Loft Storage',
      'Flower Box Ready',
      'Free Delivery & Setup'
    ],
    images: [
      '/assets/assets/images/10x24-studio-shed-1of4.webp',
      '/assets/assets/images/12x24-a-frameshed.webp'
    ],
    videos: [],
    createdAt: '2024-03-05T14:00:00Z'
  },
  {
    id: 9,
    name: '14x28 Garage/Workshop Combo',
    brand: 'Pro Series',
    dealerName: 'Desert Sun Buildings',
    dealerLocation: 'Albuquerque, NM',
    model: 'Garage Combo',
    shedType: 'garage',
    size: '14x28',
    width: 14,
    depth: 28,
    height: 12,
    squareFeet: 392,
    price: 18999,
    salePrice: null,
    depositAmount: 2000,
    material: 'Wood',
    roofStyle: 'Gable',
    roofMaterial: 'Metal Standing Seam',
    sidingType: 'LP SmartSide',
    sidingColor: 'White',
    trimColor: 'Black',
    roofColor: 'Red',
    floorType: '3/4" Treated Plywood',
    foundation: 'Concrete Slab (Customer)',
    condition: 'New',
    status: 'available',
    serialNumber: 'PS-2024-001',
    stockNumber: 'SH009',
    yearBuilt: 2024,
    warranty: '10-Year Limited',
    warrantyYears: 10,
    doors: '9x7 Overhead Garage Door + Walk-in Door',
    windows: '4 - 24x36 Windows',
    loft: true,
    workbench: true,
    shelving: true,
    electrical: true,
    insulation: true,
    deliveryIncluded: false,
    setupIncluded: true,
    description: 'Full-size single-car garage with attached workshop area. Features overhead garage door, full electrical package, and insulation. Perfect for car enthusiasts, woodworkers, or anyone needing serious workspace.',
    features: [
      '9x7 Overhead Garage Door',
      'Walk-in Side Door',
      '4 Windows',
      '200A Electrical Panel',
      'Fully Insulated',
      'Workshop Area',
      'Loft Storage',
      'Built-in Workbench',
      'Metal Standing Seam Roof',
      '10-Year Warranty'
    ],
    images: [
      '/assets/assets/images/garage-shed-12x24.webp',
      '/assets/assets/images/10x20-studio-shed-4of4.webp'
    ],
    videos: [],
    createdAt: '2024-03-10T09:00:00Z'
  },
  {
    id: 10,
    name: '8x8 Value Storage Shed',
    brand: 'Budget',
    dealerName: 'Lone Star Sheds',
    dealerLocation: 'Houston, TX',
    model: 'Value Storage',
    shedType: 'utility',
    size: '8x8',
    width: 8,
    depth: 8,
    height: 7.5,
    squareFeet: 64,
    price: 1999,
    salePrice: 1799,
    depositAmount: 200,
    material: 'Wood',
    roofStyle: 'Gable',
    roofMaterial: 'Metal',
    sidingType: 'T1-11',
    sidingColor: 'Brown',
    trimColor: 'Brown',
    roofColor: 'Brown',
    floorType: 'Treated Plywood',
    foundation: 'Skid',
    condition: 'New',
    status: 'available',
    serialNumber: 'BV-2024-055',
    stockNumber: 'SH010',
    yearBuilt: 2024,
    warranty: '3-Year Limited',
    warrantyYears: 3,
    doors: '4ft Single Door',
    windows: '0',
    loft: false,
    workbench: false,
    shelving: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'No-frills storage shed at an unbeatable price. Great for basic storage of lawn equipment, bikes, and outdoor gear. Simple, durable, and affordable.',
    features: [
      '4ft Wide Door',
      'Metal Roof',
      'Treated Floor',
      'Free Delivery & Setup',
      'Best Value'
    ],
    images: [
      '/assets/assets/images/12x24-shed.webp',
      '/assets/assets/images/10x20-studio-shed-2of4.webp'
    ],
    videos: [],
    createdAt: '2024-03-15T11:30:00Z'
  },
  {
    id: 11,
    name: '10x14 Quaker Style Shed',
    brand: 'Heritage',
    dealerName: 'Bayou Barns',
    dealerLocation: 'New Orleans, LA',
    model: 'Quaker',
    shedType: 'quaker',
    size: '10x14',
    width: 10,
    depth: 14,
    height: 9,
    squareFeet: 140,
    price: 5499,
    salePrice: null,
    depositAmount: 550,
    material: 'Wood',
    roofStyle: 'Quaker (Offset Peak)',
    roofMaterial: 'Architectural Shingles',
    sidingType: 'LP SmartSide',
    sidingColor: 'Clay',
    trimColor: 'Ivory',
    roofColor: 'Pewter',
    floorType: 'Treated Plywood',
    foundation: 'Skid',
    condition: 'New',
    status: 'available',
    serialNumber: 'HQ-2024-007',
    stockNumber: 'SH011',
    yearBuilt: 2024,
    warranty: '5-Year Limited',
    warrantyYears: 5,
    doors: '6ft Double Door',
    windows: '2 - 24x36 Windows',
    loft: true,
    workbench: false,
    shelving: false,
    electrical: false,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Distinctive Quaker-style roof with offset peak provides extra headroom and a unique look. The taller front wall makes this perfect for storing larger items while the loft adds bonus storage space.',
    features: [
      'Quaker Offset Roof Design',
      '6ft Double Doors',
      '2 Windows',
      'Extra Headroom',
      'Loft Storage',
      'LP SmartSide Siding',
      'Free Delivery & Setup'
    ],
    images: [
      '/assets/assets/images/12x24-a-frameshed.webp',
      '/assets/assets/images/10x20-studio-shed-3of4.webp'
    ],
    videos: [],
    createdAt: '2024-03-20T15:00:00Z'
  },
  {
    id: 12,
    name: '12x12 Cabana Pool House',
    brand: 'Modern',
    dealerName: 'Rocky Mountain Sheds',
    dealerLocation: 'Fort Collins, CO',
    model: 'Cabana',
    shedType: 'cabana',
    size: '12x12',
    width: 12,
    depth: 12,
    height: 10,
    squareFeet: 144,
    price: 9999,
    salePrice: null,
    depositAmount: 1000,
    material: 'Wood',
    roofStyle: 'Hip',
    roofMaterial: 'Metal Standing Seam',
    sidingType: 'Cedar Shake',
    sidingColor: 'Natural',
    trimColor: 'White',
    roofColor: 'Copper',
    floorType: 'Composite Decking',
    foundation: 'Concrete Piers',
    condition: 'New',
    status: 'available',
    serialNumber: 'MC-2024-005',
    stockNumber: 'SH012',
    yearBuilt: 2024,
    warranty: '10-Year Limited',
    warrantyYears: 10,
    doors: 'Bi-Fold Doors (Full Opening)',
    windows: 'Louvered Panels',
    loft: false,
    workbench: false,
    shelving: false,
    electrical: true,
    insulation: false,
    deliveryIncluded: true,
    setupIncluded: true,
    description: 'Luxurious pool house cabana with tropical vibes. Features bi-fold doors that open completely to create an indoor-outdoor space. Perfect for pool parties, outdoor entertaining, or as a changing room.',
    features: [
      'Full-Width Bi-Fold Doors',
      'Hip Roof Design',
      'Cedar Shake Siding',
      'Louvered Side Panels',
      'Composite Decking Floor',
      'Pre-Wired Electrical',
      'Copper-Look Metal Roof',
      '10-Year Warranty'
    ],
    images: [
      '/assets/assets/images/shed-with-deck.webp',
      '/assets/assets/images/10x20-studio-shed-2of4.webp'
    ],
    videos: [],
    createdAt: '2024-03-25T10:30:00Z'
  }
];

// Shed types for filtering
export const shedTypes = [
  { value: 'barn', label: 'Barn Style' },
  { value: 'gable', label: 'Gable' },
  { value: 'workshop', label: 'Workshop' },
  { value: 'lean-to', label: 'Lean-To' },
  { value: 'ranch', label: 'Ranch' },
  { value: 'studio', label: 'Studio' },
  { value: 'cottage', label: 'Cottage' },
  { value: 'garage', label: 'Garage' },
  { value: 'utility', label: 'Utility' },
  { value: 'quaker', label: 'Quaker' },
  { value: 'cabana', label: 'Cabana/Pool House' }
];

// Material options
export const shedMaterials = [
  { value: 'wood', label: 'Wood' },
  { value: 'metal', label: 'Metal' },
  { value: 'vinyl', label: 'Vinyl' },
  { value: 'resin', label: 'Resin/Plastic' }
];

// Common shed sizes
export const shedSizes = [
  { value: '6x8', label: '6x8 (48 sq ft)' },
  { value: '8x8', label: '8x8 (64 sq ft)' },
  { value: '8x10', label: '8x10 (80 sq ft)' },
  { value: '8x12', label: '8x12 (96 sq ft)' },
  { value: '10x10', label: '10x10 (100 sq ft)' },
  { value: '10x12', label: '10x12 (120 sq ft)' },
  { value: '10x14', label: '10x14 (140 sq ft)' },
  { value: '10x16', label: '10x16 (160 sq ft)' },
  { value: '12x12', label: '12x12 (144 sq ft)' },
  { value: '12x16', label: '12x16 (192 sq ft)' },
  { value: '12x20', label: '12x20 (240 sq ft)' },
  { value: '12x24', label: '12x24 (288 sq ft)' },
  { value: '14x20', label: '14x20 (280 sq ft)' },
  { value: '14x28', label: '14x28 (392 sq ft)' }
];

export default sampleSheds;
